import { render, staticRenderFns } from "./CompContestImageVideoType.vue?vue&type=template&id=b77c40f0&scoped=true"
import script from "./CompContestImageVideoType.vue?vue&type=script&setup=true&lang=js"
export * from "./CompContestImageVideoType.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b77c40f0",
  null
  
)

export default component.exports